export const formatPhoneNumber = (value: string | undefined): string => {
  if (!value) {
    return "";
  }
  const length = value.length;
  if (length < 4) {
    return value.replace(/(\d+)/, "($1");
  }
  if (length < 7) {
    return value.replace(/(\d{3})(\d+)/, "($1) $2");
  }
  if (length <= 10) {
    return value.replace(/(\d{3})(\d{3})(\d+)/, "($1) $2-$3");
  }
  if (length > 10) {
    const countryCodeLength = length - 10;
    return value.replace(
      new RegExp(`(\\d{${countryCodeLength}})(\\d{3})(\\d{3})(\\d{4})`),
      "+$1 ($2) $3-$4",
    );
  }
  return "";
};

export const formatAndObscurePhoneNumber = (
  value: string | undefined,
): string => {
  const formattedValue = formatPhoneNumber(value);
  return formattedValue.replace(/\d{4}$/g, "XXXX");
};
